import React, { useState } from "react";
import "cropperjs/dist/cropper.min.css";
import { Box } from "@mui/material";
import styles from "./style.module.css";
import ImageCropper from "./cropper";
import { uploadImage } from "../../../../../../../../../helpers/uploadImageToS3";
import imageCompression from "browser-image-compression";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsModalProjectOpen,
  setOriginalProjectImage,
  setSelectedProjectImage,
  setCroppedImage,
} from "../../../../../../../../../store/slices/profile/projectCoverImageSlice";

const EditProjectImage = () => {
  const dispatch = useDispatch();
  const { selectedProjectImage } = useSelector(
    (state) => state.projectCoverImage
  );

  const [isProjectUploading, setIsProjectUploading] = useState(false);

  const handleCrop = async (croppedImage) => {
    try {
      const blob = new Blob([croppedImage], { type: "image/png" });
      const originalBlob = blob;

      // Compress the image using browser-image-compression library
      const options = {
        maxSizeMB: 1, // Set the maximum size of the compressed image to 0.5 MB
        maxWidthOrHeight: 800, // Set the maximum width or height of the compressed image
        useWebWorker: true, // Use a web worker for faster compression
        quality: 1, // Adjust the quality parameter (0.7 is a good starting point)
      };

      const compressedBlob = await imageCompression(originalBlob, options);

      const blobURL = await uploadImage(
        compressedBlob,
        "project-cover-image-" + Math.random() + "-v-" + new Date().getTime()
      );

      dispatch(setCroppedImage(blobURL));
      dispatch(setSelectedProjectImage(null));
      dispatch(setIsModalProjectOpen(false));

      // handle original image upload
      const response = await fetch(selectedProjectImage);
      const blobData = await response.blob();

      // Compress the image using browser-image-compression library
      const originalOptions = {
        maxSizeMB: 1, // Set the maximum size of the compressed image
        maxWidthOrHeight: 600, // Set the maximum width or height of the compressed image
        useWebWorker: true, // Use a web worker for faster compression
        quality: 1,
      };

      const compressedOrBlob = await imageCompression(
        blobData,
        originalOptions
      );

      const originalImageUrl = await uploadImage(
        compressedOrBlob,
        "original-project-cover-image-" + "-v-" + new Date().getTime()
      );

      dispatch(setOriginalProjectImage(originalImageUrl));
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancel = () => {
    dispatch(setSelectedProjectImage(null));
    dispatch(setIsModalProjectOpen(false));
  };

  return (
    <Box className={styles.parent}>
      <Box className={styles.container}>
        <ImageCropper
          imageSrc={selectedProjectImage}
          onCrop={handleCrop}
          onCancel={handleCancel}
          isProfileUploading={isProjectUploading}
          setIsProfileUploading={setIsProjectUploading}
        />
      </Box>
    </Box>
  );
};

export default EditProjectImage;
